var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n    "),(_vm.required)?_c('span',{staticClass:"label__required"},[_vm._v("*")]):_vm._e(),_vm._v(" "),(_vm.description != '')?_c('span',{staticClass:"label__info",domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-685b9505","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/Label.vue
// module id = null
// module chunks = 